import React from 'react';
import { ArrowRight, Building2, MessageSquare, ClipboardCheck } from 'lucide-react';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white">
        <div className="container mx-auto px-6 py-24">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">
              Streamline Your Property Inspections with AI
            </h1>
            <p className="text-xl mb-8">
              Automate follow-ups, gather insights, and close deals faster with our intelligent virtual assistant.
            </p>
            <button className="bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-blue-50 flex items-center gap-2">
              Get Started <ArrowRight className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="container mx-auto px-6 py-24">
        <div className="grid md:grid-cols-3 gap-12">
          <div className="text-center">
            <Building2 className="w-12 h-12 mx-auto mb-6 text-blue-600" />
            <h3 className="text-xl font-semibold mb-4">Smart Property Management</h3>
            <p className="text-gray-600">
              Efficiently manage your property inspections and customer communications in one place.
            </p>
          </div>
          <div className="text-center">
            <MessageSquare className="w-12 h-12 mx-auto mb-6 text-blue-600" />
            <h3 className="text-xl font-semibold mb-4">AI-Powered Follow-ups</h3>
            <p className="text-gray-600">
              Let our virtual assistant handle inspection follow-ups automatically via SMS.
            </p>
          </div>
          <div className="text-center">
            <ClipboardCheck className="w-12 h-12 mx-auto mb-6 text-blue-600" />
            <h3 className="text-xl font-semibold mb-4">Detailed Reports</h3>
            <p className="text-gray-600">
              Get comprehensive insights and recommendations based on customer interactions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;